import { map } from "lodash";
import { useQuery } from "react-query";
import { SimpleMembership } from "../../../../../@types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";

type SurveyOptionVotersArgs = {
  optionId: string;
  show: boolean;
  activityId?: string;
};

export default function SurveyOptionVoters({
  activityId,
  optionId,
  show,
}: SurveyOptionVotersArgs) {
  const { data: voters, isLoading } = useQuery<SimpleMembership[]>(
    `/api/v1/activities/${activityId}/votes/${optionId}`,
    { enabled: show && !!activityId },
  );

  return (
    <div className="flex flex-wrap gap-2 text-sm mt-1">
      {isLoading ? (
        <FontAwesomeIcon icon={faSpinner} spin />
      ) : (
        map(voters, ({ id, name }) => (
          <a key={id} href={`/members/${id}`}>
            {name}
          </a>
        ))
      )}
    </div>
  );
}
